import React, { useEffect, useState } from "react";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem("bs_cookies_ok")) setShow(true);
  }, []);

  if (!show) return null;

  const accept = () => {
    localStorage.setItem("bs_cookies_ok", "1");
    window.dispatchEvent(new Event("bs-cookies-accepted"));
    setShow(false);
  };

  const refuse = () => {
    localStorage.setItem("bs_cookies_ok", "0");
    setShow(false);
  };

  return (
    <div
      data-testid="cookie-overlay"
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center sm:justify-end p-4 sm:p-8"
      style={{ background: "rgba(5, 5, 5, 0.55)", backdropFilter: "blur(6px)" }}
      role="dialog"
      aria-modal="true"
    >
      <div
        data-testid="cookie-banner"
        className="brutal-card w-full sm:max-w-md p-6"
        style={{ background: "#FFD01E" }}
      >
        <h4 className="font-display text-2xl mb-2">Cookies, miam.</h4>
        <p className="text-sm mb-4">
          On utilise quelques cookies pour mesurer l&apos;audience. Pas de pistage cra-cra.
        </p>
        <div className="flex gap-2">
          <button
            data-testid="accept-cookies"
            onClick={accept}
            className="brutal-btn brutal-btn-coral !py-2 !px-4 !text-xs"
          >
            OK, j&apos;accepte
          </button>
          <button
            data-testid="refuse-cookies"
            onClick={refuse}
            className="brutal-btn brutal-btn-cream !py-2 !px-4 !text-xs"
          >
            Refuser
          </button>
        </div>
      </div>
    </div>
  );
}
